@if (!properties) {
  <i class="slight">Select a layer...</i>
}
@if (properties && currentLayer) {
  @if (selectedEffectId) {
    @if (effectsList && effectsList.length > 0) {
      <div class="effects-header">
        <p-button
          icon="pi pi-caret-left"
          label="Back"
          (onClick)="this.selectEffectId.emit()"
          size="small"
          outlined
          rounded>
        </p-button>
        <div class="layer-effect">
          <h4>Layer Effects:</h4>
          <p-listbox
            [options]="effectsList"
            [ngModel]="selectedEffectId"
            optionValue="id"
            optionLabel="effectType"
            (onChange)="onSelectedEffect($event)"
            >
          </p-listbox>
        </div>
      </div>
    }
  }
  @else {
    <div class="layer-type">
      <h4>{{currentLayer.layerType}} Layer</h4>
    </div>
  }
  <div class="list" [formGroup]="form">
    <ng-container [ngTemplateOutlet]="propertyTemplate" [ngTemplateOutletContext]="{elementProperties: properties.forms}" />
    <ng-template #propertyTemplate let-elementProperties="elementProperties">
      @for (field of elementProperties; track field){
        @switch (field.type) {
          @case (formTypes.Container) {
            <div class="container-grouping">
              <ng-container *ngTemplateOutlet="labelHint; context: { label: field.label, hint: field.hint }" />
              <ng-container [ngTemplateOutlet]="propertyTemplate" [ngTemplateOutletContext]="{elementProperties: field.children}" />
            </div>
          }
          @case (formTypes.Text) {
            <div class="text-field">
              <ng-container *ngTemplateOutlet="labelHint; context: { label: field.label, hint: field.hint }" />
              <input [id]="field.id" type="text" [placeholder]="field.placeholder" pInputText [formControlName]="field.id"/>
            </div>
          }
          @case (formTypes.RangeSlider) {
            @if (field.sliderOptions) {
              <div class="slider-field">
                <ng-container *ngTemplateOutlet="labelHint; context: { label: field.label, hint: field.hint }" />
                <div class="slider-container">
                  <p-slider
                    animate
                    [range]="true"
                    [min]="field.sliderOptions.min"
                    [max]="field.sliderOptions.max"
                    [step]="field.sliderOptions.step"
                    [formControlName]="field.id"
                    >
                  </p-slider>
                </div>
              </div>
            }
          }
          @case (formTypes.SliderNumber) {
            @if (field.sliderOptions) {
              <div class="slider-field">
                <ng-container *ngTemplateOutlet="labelHint; context: { label: field.label, hint: field.hint }" />
                <div class="slider-container">
                  <p-slider
                    animate
                    [min]="field.sliderOptions.min"
                    [max]="field.sliderOptions.max"
                    [step]="field.sliderOptions.step"
                    [formControlName]="field.id"
                    />
                </div>
              </div>
            }
          }
          @case (formTypes.InputNumber) {
            <div class="number-input-field">
              <ng-container *ngTemplateOutlet="labelHint; context: { label: field.label, hint: field.hint }" />
              <p-inputNumber [formControlName]="field.id" mode="decimal" [useGrouping]="false" [suffix]="field.suffix" [minFractionDigits]="0" [maxFractionDigits]="100"></p-inputNumber>
            </div>
          }
          @case (formTypes.Select) {
            <div class="select-field">
              <ng-container *ngTemplateOutlet="labelHint; context: { label: field.label, hint: field.hint }" />
              <p-dropdown
                [formControlName]="field.id"
                [options]="field.options"
                optionLabel="label"
                [placeholder]="field.placeholder" />
            </div>
          }
          @case (formTypes.Gradient) {
            <div class="gradient-field">
              <ng-container *ngTemplateOutlet="labelHint; context: { label: field.label, hint: field.hint }" />
              <app-gradient-picker
                [formControlName]="field.id"
                ></app-gradient-picker>
            </div>
          }
          @case (formTypes.Color) {
            <div class="color-field">
              <ng-container *ngTemplateOutlet="labelHint; context: { label: field.label, hint: field.hint }" />
              <div class="color-list">
                <p-colorPicker [formControlName]="field.id"/>
                <input [id]="field.id" [placeholder]="field.placeholder" type="text" pInputText [formControlName]="field.id + '_text'"/>
              </div>
            </div>
          }
          @case (formTypes.Multiselect) {
            <div class="multiselect-field">
              <ng-container *ngTemplateOutlet="labelHint; context: { label: field.label, hint: field.hint }" />
              <p-multiSelect
                [options]="field.options"
                [virtualScroll]='true'
                [virtualScrollItemSize]="43"
                [formControlName]="field.id"
                optionLabel="label"
                [placeholder]="field.placeholder"
              />
            </div>
          }
          @case (formTypes.Checkbox) {
            <div class="text-field">
              <ng-container *ngTemplateOutlet="labelHint; context: { label: field.label, hint: field.hint }" />
              <p-checkbox
                [formControlName]="field.id"
                [binary]="true"
                />
            </div>
          }
        }
      }
    </ng-template>

    @if (effectsList && effectsList.length > 0 && !selectedEffectId) {
      <div class="layer-effect">
        <h4>Layer Effects:</h4>
        <p-listbox
          [options]="effectsList"
          optionLabel="effectType"
          (onChange)="onSelectedEffect($event)"
          >
        </p-listbox>
      </div>
    }
  </div>
}

<ng-template #labelHint let-hint="hint" let-label="label">
  <div class="label-hint">
    <p class="label">{{ label }}</p>
    @if (hint) {
      <i
        [pTooltip]="hint"
        tooltipPosition="left"
        class="pi pi-question-circle"
        size="small"
        severity="info"
      ></i>
    }
  </div>
</ng-template>
